import { defineStore } from 'pinia';

export const useStore = defineStore({
  id: 'auth',

  state: () => {
    return {
      sapCustomerId: '',
      endCustomerId: '',
      tok: '',
      isTokValid: true,
    };
  },

  actions: {
    setSapCustomerId(id: string) {
      this.sapCustomerId = id;
    },
    setEndCustomerId(id: string) {
      this.endCustomerId = id;
    },
    setTok(token: string) {
      this.tok = token;
    },
    setIsTokValid(isTokenValid: boolean) {
      this.isTokValid = isTokenValid;
    },
  },
});
